import { useMediaControls } from '@vueuse/core'

export const useAudioPlayer = () => {
  const src = useState<string>('audio-src')
  const playerEl = useState<HTMLAudioElement>('audio-player-element')
  const controls = useMediaControls(playerEl)
  const isLoading = useState<boolean>('audio-loading', () => false)

  const formatted = computed(() => ({
    currentTime: formatTime(controls.currentTime.value),
    duration: formatTime(controls.duration.value),
    percentagePlayed: `${controls.currentTime.value / controls.duration.value * 100}%`,
    // the floored percentage is used to announce the progress of the audio to screen readers
    flooredPercentagePlayed: `${Math.floor(controls.currentTime.value / controls.duration.value * 100)}%`,
  }))

  const play = () => {
    if (src.value && playerEl.value
      && playerEl.value.readyState === HTMLMediaElement.HAVE_ENOUGH_DATA)
      playerEl.value.play()
  }

  const pause = () => {
    if (playerEl.value)
      playerEl.value.pause()
  }

  const playPause = () => {
    if (playerEl.value.paused)
      play()
    else pause()
  }

  const close = () => {
    if (playerEl.value)
      src.value = ''
  }

  return {
    src,
    playerEl,
    controls,
    isLoading,
    formatted,
    play,
    pause,
    close,
    playPause,
  }
}

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}
